import { render, staticRenderFns } from "./showPic.vue?vue&type=template&id=6899bf35&scoped=true&"
import script from "./showPic.vue?vue&type=script&lang=js&"
export * from "./showPic.vue?vue&type=script&lang=js&"
import style0 from "./showPic.vue?vue&type=style&index=0&id=6899bf35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899bf35",
  null
  
)

export default component.exports